/* eslint-disable no-unused-expressions,no-unused-expressions */
import { Component } from 'react';
import { actions, Control, Errors } from 'forms/rrf';
import PropTypes from 'prop-types';

import './image-upload.css';
import noPhoto from '../../../../assets/img/no_photo.png';
import Button from '../../button';

const uploadStyle = {
  marginTop: '18px',
  lineHeight: '14px',
  padding: '5px 10px'
};

class ImageUpload extends Component {
  handleImageChange = (model, value) => {
    const reader = new FileReader();
    const file = value[0];

    if (file) {
      const fileSize = this.checkFileSize(file.size);
      const fileType = this.checkFileType(file.type);

      const errors = [];

      if (!fileSize) {
        errors.push('The selected file reaches the upload limit (1MB)');
      }

      if (!fileType) {
        errors.push('The selected file is not a valid image file');
      }

      if (!errors.length) {
        reader.onloadend = () => {
          this.setState({
            file,
            imagePreviewUrl: reader.result
          });
          this.props.onImageLoaded && this.props.onImageLoaded(reader.result);
        };

        reader.readAsDataURL(file);
      } else {
        this.setState({
          file: '',
          imagePreviewUrl: noPhoto,
        });
        this.props.onImageLoaded && this.props.onImageLoaded(null);
      }
    }

    return (dispatch) => {
      dispatch(actions.change(model, file));
    };
  };

  checkFileType = type => !type || !this.props.type || this.props.type.some(val => val === type);
  checkFileSize = size => !size || !this.props.sizeLimit || size < this.props.sizeLimit;

  constructor(props) {
    super(props);

    this.state = { file: '' };
  }

  render() {
    let { imagePreviewUrl } = this.state;

    if (!imagePreviewUrl) {
      imagePreviewUrl = this.props.source;
    }

    const { upload } = this.props;
    const $imagePreview = imagePreviewUrl ? (
      <img src={imagePreviewUrl} />
    ) : (<img src={noPhoto} />);

    return (
      <div className="previewComponent form-group">
        <div className="imgPreview">{$imagePreview}</div>
        <Control.file
          changeAction={this.handleImageChange}
          className="fileInput"
          id={this.props.model}
          model={this.props.model}
          name={this.props.model}
          validators={{
            fileSize: val => !val || this.checkFileSize(val.size),
            fileType: val => !val || this.checkFileType(val.type),
            required: val => !this.props.required || this.props.source || val
          }}
        />
        <h4 className="my-profile-details-image-label">
          {this.props.label}
          {this.props.required && '*'}
        </h4>
        <label className="btn btn-form btn-form-grey" htmlFor={this.props.model}>
          {this.props.buttonLabel}
        </label>
        {upload && (
          <Button color="grey" style={uploadStyle} submit inline>
            Upload
          </Button>
        )}
        <div>
          {this.state.file.name}
        </div>
        <Errors
          className="errors"
          messages={{
            fileSize: `The selected file reaches the upload limit (${this.props.sizeLimit / 1024} Kb)`,
            fileType: 'The selected file is not a valid image file',
            required: 'This field is required'
          }}
          model={this.props.model}
          show={{touched: true}}
        />
      </div>
    );
  }
}

ImageUpload.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  onImageLoaded: PropTypes.func,
  type: PropTypes.arrayOf(PropTypes.string),
  sizeLimit: PropTypes.number,
  required: PropTypes.bool,
  upload: PropTypes.bool,
};

ImageUpload.defaultProps = {
  upload: false,
  model: '.image',
  label: 'Upload a photo',
  buttonLabel: 'Choose a file'
};

export default ImageUpload;
